import request from "@/utils/request";

export default function getHistoryUsers() {
    return request({
        url: `/chatLog/getHistoryUsers`,
        method: 'get',
    })
}